/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import UtagData, { EventTag } from "../config/tagging";
import { findQuestionById } from "./AOFormUtils";

const getBrowserLanguage = () => {
    const browserLanguage = (navigator.language || navigator.browserLanguage);
    const en = "en-US";
    const zh = "zh-CN";
    if (browserLanguage.indexOf("zh") !== -1) {
        return zh
    } else {
        return en
    }
};

export const loadLanguage = () => {
    return localStorage.getItem("saved_language") || getBrowserLanguage()
};

export const storedLanguage = newLanguage => {
    setHtmlLang(newLanguage)
    localStorage.setItem("saved_language", newLanguage)
};

export const getContentByLocal = (locals, currentLanguage) => {
    if (!locals) { return null }
    const [lang] = (currentLanguage || this.loadLanguage()).split(/-/);
    const [currentItem] = locals.filter(obj => obj.locale.toLowerCase() === lang.toLowerCase());
    return currentItem && currentItem.detail
};

export const getSessionDatas = () => {
    return JSON.parse(sessionStorage.getItem("rbbInfo")) || {};
};
export const saveSessionDatas = (datas, keyList) => {
    if (!!datas) {
        keyList.map((item) => {
            setItemToSession({ [item]: datas[item] || "" });
            return (setItemToSession({ [item]: datas[item] || "" }));
        });
    }
};
export const setItemToSession = (newParams) => {
    const oldRbbInfo = getSessionDatas();

    const newRbbInfo = { ...oldRbbInfo, ...newParams };

    sessionStorage.setItem("rbbInfo", JSON.stringify(newRbbInfo));
};

export const clearUserDatas = () => {
    sessionStorage.clear()
}

/*
 * Judging whether an object is empty
 */
export const isEmptyObject = (obj) => {
    for (const n in obj) { return false }
    return true;
};
export const isStringEmpty = (str) => {
    return (!str || 0 === str.length);
};

export const isArray = (o) => {
    return Object.prototype.toString.call(o) === '[object Array]';
};

export const isSoleTrader = (application) => {
    let result = false;
    const entityType = findQuestionById(application, 'Q001-002-002');
    if (!!entityType && !!entityType.userAnswer && !!entityType.userAnswer.chosenAnswerId) {
        result = entityType.userAnswer.chosenAnswerId === "A001-002-002:001" || entityType.userAnswer.chosenAnswerId === "A001-002-002:002"
    }
    return result
};

export const getCountryListFormLang = (countryListDatas, lang) => {
    if (countryListDatas && countryListDatas.length > 0) {
        let result = countryListDatas[0];
        if (loadLanguage() === 'en-US' || (lang && lang === 'en-US')) {
            result = countryListDatas[1];
        }
        return result;
    } else {
        return null;
    }
        
}

export const getUserAgent = () => {
    const u = navigator.userAgent.toLowerCase() || navigator.appVersion.toLowerCase();

    return ({
        // toString: u,
        version: (u.match(/.+(?:rv|it|ra|ie)[/: ]([\d.]+)/) || [])[1],
        msie: /(msie|trident|edge)/.test(u) && !/opera/.test(u), //IE
        mozilla: /mozilla/.test(u) && !/(compatible|webkit)/.test(u), //Firefox
        safari: /safari/.test(u) && !/chrome/.test(u), //Safari
        chrome: /chrome/.test(u), //Chrome
        opera: /opera/.test(u), //Opera
        presto: u.indexOf('presto/') > -1, //Presto
        webKit: u.indexOf('applewebkit/') > -1, //Webkit
        gecko: u.indexOf('gecko/') > -1 && u.indexOf('khtml') === -1, //Gecko
        mobile: !!u.match(/applewebkit.*mobile.*/) || !!u.match(/windows phone.*iemobile.*/),
        iOS: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/),
        aOS: u.indexOf('android') > -1,
        winPhone: !!u.match(/windows phone.*iemobile.*/),
        iPhone: u.indexOf('iphone') > -1,
        iPad: u.indexOf('ipad') > -1,
        webApp: !!u.match(/applewebkit.*mobile.*/) && u.indexOf('safari/') === -1,
        language: (navigator.browserLanguage || navigator.language).toLowerCase(),
        IEVersion: function () {
            let verNum = null;
            if (this.msie === true) {
                let v = u.match(/msie (\d+).(\d+)/);
                if (v !== null) {
                    verNum = [parseInt(v[1] || 0, 10)];
                } else {
                    v = u.match(/rv:/);
                    if (v !== null) {
                        if (v.index > -1) verNum = u.substr(v.index + 3, 2);
                    } else {
                        v = u.match(/edge/);
                        if (v.index > -1) verNum = u.substr(v.index + 5, 2);
                    }
                }
            }
            return verNum;
        },
        iOSVersion: function () {
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (v !== null) return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
            return v;
        }
    }
    );
};

/**
 * Deep copy
 */

export const deepClone = (obj) => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    switch (Object.prototype.toString.call(obj)) {
        case '[object Array]': {
            const result = new Array(obj.length);
            for (let i = 0; i < result.length; ++i) {
                result[i] = deepClone(obj[i]);
            }
            return result;
        }

        // Object.prototype.toString.call(new XxxError) returns '[object Error]'
        case '[object Error]': {
            const result = new obj.constructor(obj.message);
            result.stack = obj.stack; // hack...
            return result;
        }

        case '[object Date]':
        case '[object RegExp]':
        case '[object Int8Array]':
        case '[object Uint8Array]':
        case '[object Uint8ClampedArray]':
        case '[object Int16Array]':
        case '[object Uint16Array]':
        case '[object Int32Array]':
        case '[object Uint32Array]':
        case '[object Float32Array]':
        case '[object Float64Array]':
        case '[object Map]':
        case '[object Set]':
            return new obj.constructor(obj);

        case '[object Object]': {
            const keys = Object.keys(obj);
            const result = {};
            for (let i = 0; i < keys.length; ++i) {
                const key = keys[i];
                result[key] = deepClone(obj[key]);
            }
            return result;
        }

        default: {
            throw new Error("Unable to copy obj! Its type isn't supported.");
        }
    }
};

export const isEqual = (value, other) => {

    if (value === other) {
        return true;
    }

    // Get the value type
    var type = Object.prototype.toString.call(value);

    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;

    // If items are not an object or array, return false
    if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

    // Compare the length of the length of the two items
    var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
    var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    // Compare two items
    var compare = function (item1, item2) {

        // Get the object type
        var itemType = Object.prototype.toString.call(item1);

        // If an object or array, compare recursively
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!isEqual(item1, item2)) return false;
        }

        // Otherwise, do a simple comparison
        else {

            // If the two items are not the same type, return false
            if (itemType !== Object.prototype.toString.call(item2)) return false;

            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) return false;
            } else {
                if (item1 !== item2) return false;
            }

        }
    };

    // Compare properties
    if (type === '[object Array]') {
        for (var i = 0; i < valueLen; i++) {
            if (compare(value[i], other[i]) === false) return false;
        }
    } else {
        for (var key in value) {
            if (value.hasOwnProperty(key)) {
                if (compare(value[key], other[key]) === false) return false;
            }
        }
    }

    // If nothing failed, return true
    return true;

};

/*
* Set HTML lang tag
* */

export const setHtmlLang = (lang) => {
    const newLang = (lang && lang.split('-')[0]) || 'en'
    const target = document.getElementsByTagName('html')[0];
    target.setAttribute('lang', newLang);
};

export const getDefaultTagging = () => {
    let subPage = window.location.pathname.slice(1) || 'logon';
    let item = UtagData[subPage] || UtagData.logon;
    return item;
}

// tagging request handler
export const taggingHandler = (item) => {
    let lang;
    // fix undefined getAttribute() issue.
    try {
      lang = window.document
        .querySelectorAll("[data-lang]")[0]
        .getAttribute("data-lang");
    } catch (e) {
      lang = "en";
    }
    const moreAttr = { page_language: lang, page_url: window.location.pathname + window.location.hash };

    // internal_reference_id is used to switch online-offline app togeher
    if (moreAttr.page_url !== "/" || moreAttr.page_url !== "/logon") {
      try {
        moreAttr.internal_reference_id=JSON.parse(window.sessionStorage.getItem("rbbInfo")).applicationId;
        moreAttr.user_id=JSON.parse(window.sessionStorage.getItem("rbbInfo")).userId;
	//var rbbInfo = JSON.parse(window.sessionStorage.getItem("rbbInfo"));
	//moreAttr.internal_reference_id = rbbInfo.applicationId + '_' + new Date(rbbInfo.createTime).getTime();

      } catch (e) {}
    }

    if (typeof item === "undefined") {
      item = { ...UtagData.general, ...UtagData.logon, ...moreAttr };
    } else {
      item = Object.assign({}, UtagData.general, moreAttr, item);
    }

    if (typeof window.TMS === "object" && typeof window.TMS.trackView === "function") {
        window.TMS.trackView(item);
    }
}

export const trackEvent = (param, type) => {
    if (typeof window.TMS === "object" && typeof window.TMS.trackView === "function") {
        if (EventTag[param]) {
            window.TMS.trackEvent(EventTag[param]);
        } else if (type && type === "func") {
            window.TMS.trackEvent(param);
        }
    }
}

/*
 * HTMLEncode & HTMLDecode
 */
export const HTMLEncode = (html) => {
  let temp = document.createElement("div");
  (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
  const output = temp.innerHTML;
  temp = null;
  return output;
};

export const HTMLDecode = (text) => {
  let temp = document.createElement("div");
  temp.innerHTML = text;
  const output = temp.innerText || temp.textContent;
  temp = null;
  return output;
};


/*
 * Set page title
 */
export const setTitle = (pageTitle) => {
  document.title = pageTitle;
  return true;
};

//半角->全角
export const ToDBC = (txtstring) => {
    var tmp = "";
    for(var i = 0; i < txtstring.length; i++){
        if(txtstring.charCodeAt(i) === 32) {
            tmp = tmp + String.fromCharCode(12288);
        } else if(txtstring.charCodeAt(i) < 127){
            tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i) + 65248);
        } else{
            tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i));
        }
    }
    return tmp;
};
//全角->半角
export const ToCDB = (txtstring) => {
    var tmp = "";
    for(var i = 0; i < txtstring.length; i++){
        if(txtstring.charCodeAt(i) === 1228) {
            tmp += String.fromCharCode(txtstring.charCodeAt(i) - 12256);
        } else if (txtstring.charCodeAt(i) > 65248 && txtstring.charCodeAt(i) < 65375) {
            tmp += String.fromCharCode(txtstring.charCodeAt(i) - 65248);
        } else {
            tmp += String.fromCharCode(txtstring.charCodeAt(i));
        }
    }
    return tmp;
};

export const CheckNum = (txt) => {
    var oldL = txt.length;
    var newL = txt.replace(/[^\d.]/g, "").length; // 不替换“数字和点”后返回它们的长度。
    if(oldL === newL) {
        var newStr = txt.split(".");
        var dotNum = newStr.length - 1;
        if(dotNum > 1) {
            return false; // 不能有1个以上的小数点
        } else if(txt.indexOf(".") === 0) {
            return false; // 小数点不能在首位
        } else if(dotNum === 1 && (newStr[dotNum].length === 0)) {
            return false; // 小数点后不能没有数字
        } else {
            return true; // 允许数字和一个小数点
        }
    } else {
        return false; // 不能输字母，汉字，特殊字符（除了小数 and 点）
    }
}

// 解密
export const decrypt = (link, type = 'test123') => {
const CryptoJS = require('crypto-js')
  try {
    let key = CryptoJS.SHA1(type);
    key = CryptoJS.SHA1(key).toString().substring(0, 32);
    key = CryptoJS.enc.Hex.parse(key)
    let decrypt = CryptoJS.AES.decrypt(link, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    })
    let result = decrypt.toString(CryptoJS.enc.Utf8);
    return JSON.parse(result)
  } catch (error) {
    return ''
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js